import React from 'react';
import { motion } from 'framer-motion';

interface AnimatedButtonProps {
  children: React.ReactNode;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
  onClick?: () => void;
  variant?: 'gentle' | 'prominent' | 'subtle';
  [key: string]: any;
}

const AnimatedButton: React.FC<AnimatedButtonProps> = ({ 
  children, 
  disabled = false, 
  variant = 'gentle',
  className,
  style,
  onClick,
  ...props 
}) => {
  const getAnimationConfig = () => {
    switch (variant) {
      case 'prominent':
        return {
          whileHover: { 
            scale: disabled ? 1 : 1.05,
            transition: { type: "spring", stiffness: 400, damping: 25 }
          },
          whileTap: { 
            scale: disabled ? 1 : 0.95,
            transition: { type: "spring", stiffness: 600, damping: 30 }
          }
        };
      case 'subtle':
        return {
          whileHover: { 
            scale: disabled ? 1 : 1.01,
            transition: { type: "spring", stiffness: 500, damping: 30 }
          },
          whileTap: { 
            scale: disabled ? 1 : 0.99,
            transition: { type: "spring", stiffness: 700, damping: 35 }
          }
        };
      case 'gentle':
      default:
        return {
          whileHover: { 
            scale: disabled ? 1 : 1.02,
            transition: { type: "spring", stiffness: 400, damping: 25 }
          },
          whileTap: { 
            scale: disabled ? 1 : 0.98,
            transition: { type: "spring", stiffness: 600, damping: 30 }
          }
        };
    }
  };

  return (
    <motion.div
      {...getAnimationConfig()}
      className={className}
      style={{ display: 'inline-block', ...style }}
      onClick={disabled ? undefined : onClick}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedButton;